// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"68edaafb","112":"4c3601e7","545":"0eb80384","705":"a04e452a","738":"0560b9f8","931":"6265e13b"}[chunkId] + ".css";
};